import type { RouteObject } from "react-router";

import EmdrBoardPage from "./ui/pages/EmdrBoardPage";
import EmdrPatientScreenPage from "./ui/pages/EmdrPatientScreenPage";
import EmdrRemotePatientPage from "./ui/pages/EmdrRemotePatientPage";

/**
 * The standalone board: protected (it saves ratings against a session) and
 * with no app chrome, like a call — the stimulus needs the screen.
 */
export const emdrBoardRoutes: RouteObject[] = [
    { path: "/emdr/session/:sessionId", element: <EmdrBoardPage /> },
    { path: "/emdr/session/:sessionId/patient", element: <EmdrPatientScreenPage /> },
];

/**
 * A board opened from the link the therapist sent. Public by design, like a
 * meeting's join link: the signed token in the URL is the authorisation.
 */
export const emdrBoardPublicRoutes: RouteObject[] = [
    { path: "/emdr/j/:token", element: <EmdrRemotePatientPage /> },
];
